export const GET_BIG_QUERY_CREATE_JOB_REQUEST = '@BigQueryProvider/GET_BIG_QUERY_CREATE_JOB_REQUEST';
export const GET_BIG_QUERY_CREATE_JOB_SUCCESS = '@BigQueryProvider/GET_BIG_QUERY_CREATE_JOB_SUCCESS';
export const GET_BIG_QUERY_CREATE_JOB_FAILED = '@BigQueryProvider/GET_BIG_QUERY_CREATE_JOB_FAILED';

export const GET_BIG_QUERY_VIEWS_LIST_REQUEST = '@BigQueryProvider/GET_BIG_QUERY_VIEWS_LIST_REQUEST';
export const GET_BIG_QUERY_VIEWS_LIST_SUCCESS = '@BigQueryProvider/GET_BIG_QUERY_VIEWS_LIST_SUCCESS';
export const GET_BIG_QUERY_VIEWS_LIST_FAILED = '@BigQueryProvider/GET_BIG_QUERY_VIEWS_LIST_FAILED';